import { isTest } from 'variables/host';
import { isIframe } from 'utils/helper-functions/is-iframe';

export interface LayoutClassNamesInput {
  layout?: string | null;
  headerStyle?: string | null;
  appearanceMode?: string | null;
  currentPage?: string | null;
  sessionType?: string | null;
  amountFieldType?: string | null;
  showBalance?: boolean | null;
  showHeaderButtons?: boolean | null;
  isPreselectedPM?: boolean;
  inputFieldStyleClass?: string;
}

export const getLayoutClassNames = ({
  layout,
  headerStyle,
  appearanceMode,
  currentPage,
  sessionType,
  amountFieldType,
  showBalance,
  showHeaderButtons,
  isPreselectedPM,
  inputFieldStyleClass,
}: LayoutClassNamesInput): string => {
  const isAmountFirst = layout === 'amount-first';
  const isPanoramicLayout = layout === 'panoramic';

  return [
    'wrapper',
    'panoramic-2-0-theme',
    isTest && '_local-env',
    isAmountFirst ? 'amount-first-layout' : 'panoramic-layout',
    amountFieldType === 'modern' && isPanoramicLayout && 'modern-amount-field',
    appearanceMode,
    sessionType === 'vt' && 'virtual_terminal',
    currentPage,
    isIframe() && 'iframe-container',
    showBalance && 'show_balance',
    isPreselectedPM === false && 'unselect_first_payment_method',
    showHeaderButtons && 'show-hide-and-back-buttons',
    headerStyle ? `${headerStyle}-header` : 'classic-header',
    inputFieldStyleClass,
  ]
    .filter((token): token is string => !!token)
    .join(' ');
};
